import { render, staticRenderFns } from "./DevisDocument.vue?vue&type=template&id=5e28d243&"
import script from "./DevisDocument.vue?vue&type=script&lang=js&"
export * from "./DevisDocument.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports